/* The CookBook videos: play while on screen, pause when off it. If the browser refuses to play
   (iOS Low Power Mode, data saver) or the visitor asked for reduced motion, the poster stays.
   Loaded by bp-cookbook, bp-recipe-hero and bp-recipe-media; runs once per page. */
(function () {
  if (window.__bpCookbookMedia) return;
  window.__bpCookbookMedia = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.25 });

  function scan() {
    document.querySelectorAll('.bp-cookbook-card__media video, .bp-recipe-hero__media video, .bp-recipe-media__tile video').forEach(function (v) {
      if (v.__bpArmed) return;
      v.__bpArmed = true;
      v.muted = true;
      v.playsInline = true;
      io.observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
